import type { AxiosRequestConfig } from 'axios';
import axios from 'axios';
import type {
  PaginateVirtualToursV2Params,
  PaginateVirtualToursV2Response,
} from '@/app-package';

/**
 * Retrieves paginated virtual tours for a specific listing with optional filters
 * @param listingId - The ID of the listing to get virtual tours for
 * @param page - The page number to retrieve (optional)
 * @param status - Filter by appointment status (optional)
 * @param dateFrom - Filter by start date (optional)
 * @param dateTo - Filter by end date (optional)
 * @param limit - Maximum number of tours to return (optional)
 */
const paginateVirtualTours = async ({
  listingId,
  page,
  status,
  dateFrom,
  dateTo,
  limit,
}: PaginateVirtualToursV2Params) => {
  const config: AxiosRequestConfig = {
    url: `/listing/${listingId}/virtual_tour/paginate`,
    method: 'get',
    params: { page, status, dateFrom, dateTo, limit },
  };

  const { data } = await axios.request<PaginateVirtualToursV2Response>(config);

  return data;
};

export default paginateVirtualTours;
